import { ReactNode } from 'react';
import { Popover, PopoverAnchor, PopoverContent, PopoverTrigger } from '@/components/ui';

interface ErpPopoverProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  trigger: ReactNode;
  content: ReactNode;
  align?: 'start' | 'center' | 'end';
  className?: string;
  contentClassName?: string;
  onOpenAutoFocus?: (event: Event) => void;
  onInteractOutside?: (event: Event) => void;
  disableToggle?: boolean;
}

export const ErpPopover: React.FC<ErpPopoverProps> = ({
  open,
  onOpenChange,
  trigger,
  content,
  align = 'start',
  className,
  contentClassName = 'w-36 p-0',
  onOpenAutoFocus,
  onInteractOutside,
  disableToggle = false
}) => {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      {disableToggle ? (
        <PopoverAnchor asChild className={className}>
          {trigger}
        </PopoverAnchor>
      ) : (
        <PopoverTrigger asChild className={className}>
          {trigger}
        </PopoverTrigger>
      )}
      <PopoverContent
        align={align}
        className={contentClassName}
        onOpenAutoFocus={onOpenAutoFocus || (e => e.preventDefault())}
        onInteractOutside={onInteractOutside}
      >
        {content}
      </PopoverContent>
    </Popover>
  );
};
